import React, { useContext, useEffect } from 'react'
import Layout from '../../../components/layout/layout'
import '../mlOutRails/mlOutRails.scss'
import chatbotsImage from '../../../images/articles/chatbots-photo.jpg'
import { LanguageContext } from '../../../components/LanguageSwitcher/LanguageContext'
import { ArticleBackLink, ArticleNextCta } from '../../../components/ArticleNav/ArticleNav'
import ArticleCta from '../../../components/ArticleCta/ArticleCta'
import ArticleListen from '../../../components/ArticleListen/ArticleListen'
import ArticleSummary from '../../../components/ArticleSummary/ArticleSummary'
import Seo, { articleJsonLd, articleBreadcrumbs } from '../../../components/Seo/Seo'


const AiChatbots = () => {
  const { translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Seo
        title='AI Chatbots and Virtual Assistants for Business'
        description={translations.BlogAiChatbots1}
        type='article'
        image={chatbotsImage}
        jsonLd={[
          articleJsonLd({
            headline: translations.BlogAiChatbots,
            description: translations.BlogAiChatbots1,
            image: chatbotsImage,
            path: '/articles/aiChatbots',
            datePublished: '2026-07-28',
            author: translations.BlogAiChatbots12,
          }),
          articleBreadcrumbs(translations.BlogAiChatbots, '/articles/aiChatbots'),
        ]}
      />
      <div className='mlrole-health-container'>

        <div className='mlrole-health healthh-box'>
          <ArticleBackLink />
          <h1 className='article-main-title'>{translations.BlogAiChatbots}</h1>
          <div className='article-author-head-container'>
            <div className='article-author-head'>
              <p>{translations.BlogAiChatbots11}</p>
              <p>•</p>
              <p>{translations.BlogAiChatbots12}</p>
            </div>
            <p className='article-author-head'>{translations.BlogAiChatbots13}</p>
          </div>

          <div className='mlrole-health-first-image-box'>
            <img src={chatbotsImage} alt='Woman reading a conversation on her smartphone' className='mlrole-health-first-image' />
          </div>
          <ArticleListen />
          <ArticleSummary id='aiChatbots' />
          <div className='mlrole-health-txt-container'>
            <div className='mlrole-health-txt-child-box'>
              <p>{translations.BlogAiChatbots1}</p>
              <p>{translations.BlogAiChatbots2}</p>

              <h2 className='article-secondaty-title'>{translations.BlogAiChatbots3}</h2>
              <p>{translations.BlogAiChatbots4}</p>
              <p>{translations.BlogAiChatbots5}</p>
              <p>{translations.BlogAiChatbots6}</p>

              <h2 className='article-secondaty-title'>{translations.BlogAiChatbots7}</h2>
              <p>{translations.BlogAiChatbots8}</p>
              <p>{translations.BlogAiChatbots9}</p>
              <p>{translations.BlogAiChatbots10}</p>
            </div>
          </div>

          <ArticleCta />
          <ArticleNextCta link='/articles/mlRoadmap' title={translations.BlogMlRoadmap} />
        </div>
      </div>
    </Layout>
  )
}

export default AiChatbots
